var map = {
	"./camera.json": 43163,
	"./common.json": 83825,
	"./docs-verification-widget.json": 69516,
	"./files-uploader.json": 76780,
	"./language-selector.json": 1448,
	"./requirements.json": 73948,
	"./validation.json": 37687,
	"lang/locales/ru/camera.json": 43163,
	"lang/locales/ru/common.json": 83825,
	"lang/locales/ru/docs-verification-widget.json": 69516,
	"lang/locales/ru/files-uploader.json": 76780,
	"lang/locales/ru/language-selector.json": 1448,
	"lang/locales/ru/requirements.json": 73948,
	"lang/locales/ru/validation.json": 37687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25004;